let lastScrollTop = 0;
const belowCorner = document.querySelector('.below_corner');
const upsellSection = document.querySelector('.custom__upsell_prd');

window.addEventListener('scroll', function () {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const upsellBottom = upsellSection.offsetTop + upsellSection.offsetHeight;
  if (scrollTop > upsellBottom) {
    if (scrollTop > lastScrollTop) {
      belowCorner.classList.add('show');
    } else {
      belowCorner.classList.remove('show');
    }
  } else {
    belowCorner.classList.remove('show');
  }
  lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
});

// UPSELL QTY SELECTOR

  function increment(x) {
    const input = document.getElementById('quantity_bls');
    let value = parseInt(input.value, 10);
    input.value = value + x;
  }

  function decrement(x) {
    const input = document.getElementById('quantity_bls');
    let value = parseInt(input.value, 10);
    if (value > x) {
      input.value = value - x;
    }
  }


$(document).ready(function () {
$('.custom_testimonial .outer_loop_new').slick({
  dots: true,
  infinite: false,
  speed: 300,
  centerMode: true,
  centerPadding: '160px',
  autoplay: false,
  arrows:false,
  slidesToShow: 5,
  slidesToScroll: 5,
  responsive: [
    {
      breakpoint: 1180,
      settings: {
        centerMode: true,
       centerPadding: '60px',
        slidesToShow: 2,
        slidesToScroll:2,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 880,
      settings: {
        centerMode: false,
        slidesToShow:2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 680,
      settings: {
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
});  

$(document).ready(function () {
  $('.product-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    autoplay: false,
    prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></button>',
    nextArrow: '<button class="slick-next" aria-label="Next" type="button"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></button>',

  });

    $("[data-fancybox]").fancybox({
        selector: '.custom_fancy-slider',
        hash: false
    });
});


if (document.querySelector('.template-collection-stone-template')) {
    const priceInfoElements = document.querySelectorAll('.per__price');
    priceInfoElements.forEach(priceInfoElement => {
        priceInfoElement.innerHTML = '/square ft.';
    });
}
if (document.querySelector('.template-collection-accessories-template')) {
    const priceInfoElements = document.querySelectorAll('.per__price');
    priceInfoElements.forEach(priceInfoElement => {
        priceInfoElement.innerHTML = '/piece';
    });
}


// collections slider

// if(window.outerWidth < 990) {

// $('.coll_slider').slick({
//   arrow:false,
//   dots:false,
//   centerMode: true,
//   centerPadding: '80px',
//   slidesToShow: 3,
//   responsive: [
//     {
//       breakpoint: 768,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: '40px',
//         slidesToShow: 3
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         arrows: false,
//         centerMode: true,
//         centerPadding: '40px',
//         slidesToShow: 1
//       }
//     }
//   ]
// });
// }


$('.home_images').slick({
  dots: true,
      arrow:false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1
});





$('.case_study').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 5,
  slidesToScroll: 1,
  prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0741/8668/6700/files/right-arrow_1.png?v=1736410621'></button>",
  nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0741/8668/6700/files/right-arrow_1.png?v=1736410621'></button>",
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
     {
      breakpoint: 989,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 749,
      settings: {
        centerMode: true,
        centerPadding: '70px',
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


$('.pro_banner').slick({
  infinite: true,
  fade: true,
  cssEase: 'linear',
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0741/8668/6700/files/Vector_6.png?v=1736849027'></button>",
    nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0741/8668/6700/files/Vector_6.png?v=1736849027'></button>"
});


  $('.project_slider').slick({
  infinite: true,
    dots: true,
  slidesToShow: 1,
  slidesToScroll: 5
});




$(document).ready(function() {
  $('.collection-grid-controller__button').on('click', function() {
    // Remove 'active' class from all buttons
    $('.collection-grid-controller__button').removeClass('active');
    
    // Add 'active' class to the clicked button
    $(this).addClass('active');

    // Get the name attribute of the clicked button
    var gridType = $(this).attr('name');

    // Update the product grid class based on the button clicked
    $('.product-grid').removeClass('grid-two-down grid-one-down').addClass(gridType);
  });
});


$(document).ready(function () {
    var $filterItem = $(".collection-filter__item");

    function handleScroll() {
        if ($(window).width() <= 768) { // Adjust breakpoint as needed
            if ($(window).scrollTop() > 500) {
                $filterItem.addClass("scrolled");
            } else {
                $filterItem.removeClass("scrolled");
            }
        } else {
            $filterItem.removeClass("scrolled"); // Remove class if resized to desktop
        }
    }

    $(window).on("scroll", handleScroll);
    $(window).on("resize", handleScroll); // Handle resize events
});

$(document).ready(function() {
    $('.footer_search_pt .search__input.field__input').on('input', function() {
      const inputLength = $(this).val().length;
      if (inputLength > 0) {
        $('body').addClass('active_input');
        } else {
        $('body').addClass('active_input');
      }
    });
  });
$(document).ready(function() {
    $('.custom_predictive_search .search__input.field__input').on('input', function() {
      const inputLength = $(this).val().length;
      if (inputLength > 0) {
        $('body').removeClass('active_input');
        } 
    });
  });
function clickCart(){
   const submitButton = document.querySelector(".product-form__submit");
       if (submitButton) {
      submitButton.click();
    }
}

function callCart(x) {
  setTimeout(function () {
    const submitButton = document.querySelector(".product-form__submit");
    const today = new Date();

    // Fixed holidays - update or make dynamic if needed
    const holidays = [
      "2025-07-04", // Independence Day
      "2025-11-27", // Thanksgiving Day
      "2025-12-25", // Christmas Day
      // Add more holidays if needed
    ];

    function formatDateToYMD(date) {
      return date.toISOString().split('T')[0];
    }

    function isWeekendOrHoliday(date) {
      const day = date.getDay();
      const formatted = formatDateToYMD(date);
      return day === 0 || day === 6 || holidays.includes(formatted);
    }

    function addWorkingDays(startDate, workingDays) {
      const date = new Date(startDate);
      let added = 0;
      while (added < workingDays) {
        date.setDate(date.getDate() + 1);
        if (!isWeekendOrHoliday(date)) {
          added++;
        }
      }
      return date;
    }

    function subtractWorkingDays(startDate, workingDays) {
      const date = new Date(startDate);
      let subtracted = 0;
      while (subtracted < workingDays) {
        date.setDate(date.getDate() - 1);
        if (!isWeekendOrHoliday(date)) {
          subtracted++;
        }
      }
      return date;
    }

    for (let i = 1; i <= 4; i++) {
      const element = document.querySelector(`.weeks__ship_${i}`);
      const weekAttr = element?.getAttribute("week");
      if (!element || !weekAttr) continue;

      const week = parseInt(weekAttr, 10);
      const deliveryDate = addWorkingDays(today, week * 5); // Convert weeks to business days
      const shipDate = subtractWorkingDays(deliveryDate, 2); // Subtract 2 business days

      const formatted = shipDate.toLocaleString("default", {
        month: "short",
        day: "numeric",
      });

      element.innerHTML = formatted;
    }

    if (submitButton && x==1) {
      submitButton.click();
    }
  }, 1000);
}

document.addEventListener("DOMContentLoaded", function () {
  const today = new Date();

  const holidays = [
    "2025-11-27",
    "2025-12-25",
  ];

  function formatDateToYMD(date) {
    return date.toISOString().split('T')[0];
  }

  function isWeekendOrHoliday(date) {
    const day = date.getDay();
    const formatted = formatDateToYMD(date);
    return day === 0 || day === 6 || holidays.includes(formatted);
  }

  function addWorkingDays(startDate, workingDays) {
    const date = new Date(startDate);
    let added = 0;
    while (added < workingDays) {
      date.setDate(date.getDate() + 1);
      if (!isWeekendOrHoliday(date)) {
        added++;
      }
    }
    return date;
  }

  function subtractWorkingDays(startDate, workingDays) {
    const date = new Date(startDate);
    let subtracted = 0;
    while (subtracted < workingDays) {
      date.setDate(date.getDate() - 1);
      if (!isWeekendOrHoliday(date)) {
        subtracted++;
      }
    }
    return date;
  }

  function calculateAndDisplayShipDate(selectorPrefix) {
    for (let i = 1; i <= 4; i++) {
      const element = document.querySelector(`.${selectorPrefix}${i}`);
      const weekAttr = element?.getAttribute("week");
      if (!element || !weekAttr) continue;

      const week = parseInt(weekAttr, 10);
      const deliveryDate = addWorkingDays(today, week * 5); // Approx. business days per week = 5
      const shipDate = subtractWorkingDays(deliveryDate, 2); // Subtract 2 business days

      const formatted = shipDate.toLocaleString("default", {
        month: "short",
        day: "numeric",
      });

      element.innerHTML = formatted;
    }
  }

  calculateAndDisplayShipDate("weeks__ship_");     // e.g. weeks__ship_1, weeks__ship_2
  calculateAndDisplayShipDate("weeks__ship_2-");   // e.g. weeks__ship_2-1, weeks__ship_2-2
});

function upsellAdd(id,qty){
  const quantity = document.getElementById('quantity_bls').value;
  const varId = document.getElementById('corner_var_id').getAttribute("value");  
  if(id == 0 && qty == 0){
    if(varId && quantity){
        id = varId;
        qty = quantity;
    }
  }
  let formData = {
                   id: id,
                   quantity: qty,
                  };
                $.ajax({
                   url: '/cart/add',
                   type: 'POST',
                   data: formData,
                  success: function(response){
                    $.ajax({
                      url: '/?section_id=cart-drawer',
                      type: 'GET',
                      dataType: 'html',
                      success: function(carthtml){
                        window?.opusOpen?.();
                      }
                    })
                  }
                });
         }
function openUpsellPopup() {
      const overlay = document.getElementById('popupOverlay');
      overlay.style.display = 'flex';
    }

    function closePopup(event) {
      const overlay = document.getElementById('popupOverlay');
      if (event.target === overlay || event.target.classList.contains('close-btn')) {
        overlay.style.display = 'none';
        document.getElementById('popupImage').src = '';
      }
    }    
    
function changeName(){
  console.log('chnage name now')
  
}
    
function playPause(vId, bId) {
  const video = document.getElementById(vId);
  const button = document.getElementById(bId);
  const svg = button.querySelector("svg");

  if (video.paused) {
    video.play();
    svg.innerHTML = `
      <g class="control-icon-pause">
        <rect width="4.5" height="14" x="3.75" y="3" rx="1.5"></rect>
        <rect width="4.5" height="14" x="11.75" y="3" rx="1.5"></rect>
      </g>
    `;
  } else {
    video.pause();
    svg.innerHTML = `
      <path class="control-icon-play" d="M5 15.25V4.77a1.44 1.44 0 0 1 1.44-1.62 1.86 1.86 0 0 1 1.11.31l8.53 5c.76.44 1.17.8 1.17 1.51s-.41 1.07-1.17 1.51l-8.53 5a1.86 1.86 0 0 1-1.11.31A1.42 1.42 0 0 1 5 15.25Z"></path>
    `;
  }
}

$(document).ready(function () {
  let elem = document.querySelector('.tab_slider_1');
  let currentMode = getMode();

  function getMode() {
    const width = window.innerWidth;
    if (width <= 480) return 'mobile';
    if (width <= 992) return 'tablet';
    return 'desktop';
  }

  function getFlickityOptions(mode) {
    let groupCells;
    let contain = false;
    let prevNextButtons = true;

    switch (mode) {
      case 'mobile':
        groupCells = 2;
        contain = true;
        prevNextButtons = false;
        break;
      case 'tablet':
        groupCells = 3;
        break;
      case 'desktop':
        groupCells = 4;
        break;
    }

    return {
      pageDots: false,
      prevNextButtons: prevNextButtons,
      groupCells: groupCells,
      contain: contain
    };
  }
  let flkty = new Flickity(elem, getFlickityOptions(currentMode));
  window.addEventListener('resize', function () {
    let newMode = getMode();
    if (newMode !== currentMode) {
      currentMode = newMode;
      flkty.destroy();
      flkty = new Flickity(elem, getFlickityOptions(currentMode));
    }
  });
});


$(document).ready(function () {
  let elem = document.querySelector('.tab_slider_2');
  let currentMode = getMode();

  function getMode() {
    const width = window.innerWidth;
    if (width <= 480) return 'mobile';
    if (width <= 992) return 'tablet';
    return 'desktop';
  }

  function getFlickityOptions(mode) {
    let groupCells;
    let contain = false;
    let prevNextButtons = true;

    switch (mode) {
      case 'mobile':
        groupCells = 2;
        contain = true;
        prevNextButtons = false;
        break;
      case 'tablet':
        groupCells = 3;
        break;
      case 'desktop':
        groupCells = 4;
        break;
    }

    return {
      pageDots: false,
      prevNextButtons: prevNextButtons,
      groupCells: groupCells,
      contain: contain
    };
  }
  let flkty = new Flickity(elem, getFlickityOptions(currentMode));
  window.addEventListener('resize', function () {
    let newMode = getMode();
    if (newMode !== currentMode) {
      currentMode = newMode;
      flkty.destroy();
      flkty = new Flickity(elem, getFlickityOptions(currentMode));
    }
  });
});


$(document).ready(function () {
  if(window.outerWidth > 480) {
  $('.new_slsls').slick({
    centerMode: false,
      centerPadding: '60px',
        slidesToShow: 3,
          slidesToScroll:3,
             prevArrow:"<button type='button' class='slick-prev pull-left'><img src='https://cdn.shopify.com/s/files/1/0741/8668/6700/files/chevron_1_2.png?v=1754656273'></button>",
                 nextArrow:"<button type='button' class='slick-next pull-right'><img src='https://cdn.shopify.com/s/files/1/0741/8668/6700/files/chevron_1_1.png?v=1754656272'></button>",
                   responsive: [
                       {
                             breakpoint: 1024,
                                   settings: {
                                           arrows: false,
                                                   centerMode: false,
                                                           centerPadding: '40px',
                                                                   slidesToShow: 3,
                                                                           slidesToScroll:3,
                                                                                 }
                                                                                     },
                                                                                         {
                                                                                               breakpoint: 989,
                                                                                                     settings: {
                                                                                                             arrows: false,
                                                                                                                     centerMode: false,
                                                                                                                             centerPadding: '40px',
                                                                                                                                     slidesToShow: 2,
                                                                                                                                             slidesToScroll:2,
                                                                                                                                                   }
                                                                                                                                                       },
                                                                                                                                                           {
                                                                                                                                                                 breakpoint: 749,
                                                                                                                                                                       settings: {
                                                                                                                                                                               arrows: false,
                                                                                                                                                                                       centerMode: false,
                                                                                                                                                                                               centerPadding: '40px',
                                                                                                                                                                                                       slidesToShow: 1
                                                                                                                                                                                                             }
                                                                                                                                                                                                                 }
                                                                                                                                                                                                                   ]
                                                                                                                                                                                                                   });
                                                                                                                                                                                                                   }
                                                                                                                                                                                                                   });





// document.addEventListener("DOMContentLoaded", function () {
//     let elem = document.querySelector('.custom_slider_coll');
//     let isMobile = window.innerWidth <= 480;

//     let flkty = new Flickity(elem, {
//       groupCells: isMobile ? 2 : 3,
//       contain: true,
//       prevNextButtons: !isMobile,
//       pageDots: false,
//       cellAlign: isMobile ? 'center' : 'left'
//     });

//     // Optionally: update on resize
//     window.addEventListener('resize', function () {
//       let newIsMobile = window.innerWidth <= 480;
//       if (newIsMobile !== isMobile) {
//         isMobile = newIsMobile;
//         flkty.destroy(); 
//         flkty = new Flickity(elem, {
//           groupCells: isMobile ? 2 : 3,
//           contain: true,
//           prevNextButtons: !isMobile,
//           pageDots: false,
//           cellAlign: isMobile ? 'center' : 'left'
//         });
//       }
//     });
//   });



$(document).ready(function () {
  function initSlider() {
    const windowWidth = window.innerWidth;

    if (windowWidth >= 768) {
      if (!$('.single_slider_coll').hasClass('slick-initialized')) {
        $('.single_slider_coll').slick({
          arrows: true,
          slidesToShow: 4,
          slidesToScroll: 1,
          dots: false,
          prevArrow: `
            <button type="button" class="slick_btn slick-prev">
              <span class="block" style="height: 24px; width: 24px;">
                <svg aria-hidden="true" class="h-full w-full" fill="none" role="presentation" viewBox="0 0 16 16">
                  <title>Arrow Left</title>
                  <use href="#icon-arrow-left-16"></use>
                </svg>
              </span>
            </button>
          `,
          nextArrow: `
            <button type="button" class="slick_btn slick-next">
              <span class="block" style="height: 24px; width: 24px;">
                <svg aria-hidden="true" class="h-full w-full" fill="none" role="presentation" viewBox="0 0 16 16">
                  <title>Arrow Right</title>
                  <use href="#icon-arrow-right-16"></use>
                </svg>
              </span>
            </button>
          `
        });
      }
    } else {
      if ($('.single_slider_coll').hasClass('slick-initialized')) {
        $('.single_slider_coll').slick('unslick');
      }
    }
  }
  initSlider();
  $(window).on('resize', function () {
    initSlider();
  });
});

$(document).ready(function() {
  $('.custom_banner_slider').slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1000,
    dots: true  
  });

  let isPlaying = true;

    $('#bannerToggleAutoplay').on('click', function () {
      const svg = this.querySelector('svg');
      if (isPlaying) {
        $('.custom_banner_slider').slick('slickPause');
        svg.innerHTML = `
          <path class="control-icon-play" d="M5 15.25V4.77a1.44 1.44 0 0 1 1.44-1.62 1.86 1.86 0 0 1 1.11.31l8.53 5c.76.44 1.17.8 1.17 1.51s-.41 1.07-1.17 1.51l-8.53 5a1.86 1.86 0 0 1-1.11.31A1.42 1.42 0 0 1 5 15.25Z"></path>
        `;
      } else {
        $('.custom_banner_slider').slick('slickPlay');
        svg.innerHTML = `
          <g class="control-icon-pause">
            <rect width="4.5" height="14" x="3.75" y="3" rx="1.5"></rect>
            <rect width="4.5" height="14" x="11.75" y="3" rx="1.5"></rect>
          </g>
        `;
      }
      isPlaying = !isPlaying;
    });
});

$(document).ready(function() {
  $('.banner_sliderV2').slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1000,
    dots: true  
  });

  let isPlaying = true;

    $('#bannerToggleAutoplayV2').on('click', function () {
      const svg = this.querySelector('svg');
      if (isPlaying) {
        $('.banner_sliderV2').slick('slickPause');
        svg.innerHTML = `
          <path class="control-icon-play" d="M5 15.25V4.77a1.44 1.44 0 0 1 1.44-1.62 1.86 1.86 0 0 1 1.11.31l8.53 5c.76.44 1.17.8 1.17 1.51s-.41 1.07-1.17 1.51l-8.53 5a1.86 1.86 0 0 1-1.11.31A1.42 1.42 0 0 1 5 15.25Z"></path>
        `;
      } else {
        $('.banner_sliderV2').slick('slickPlay');
        svg.innerHTML = `
          <g class="control-icon-pause">
            <rect width="4.5" height="14" x="3.75" y="3" rx="1.5"></rect>
            <rect width="4.5" height="14" x="11.75" y="3" rx="1.5"></rect>
          </g>
        `;
      }
      isPlaying = !isPlaying;
    });
});


$(document).ready(function() {
  $('.custom_banner_slider2').slick({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 1000,
    dots: true  
  });

  let isPlaying = true;

    $('#bannerToggleAutoplay').on('click', function () {
      const svg = this.querySelector('svg');
      if (isPlaying) {
        $('.custom_banner_slider').slick('slickPause');
        svg.innerHTML = `
          <path class="control-icon-play" d="M5 15.25V4.77a1.44 1.44 0 0 1 1.44-1.62 1.86 1.86 0 0 1 1.11.31l8.53 5c.76.44 1.17.8 1.17 1.51s-.41 1.07-1.17 1.51l-8.53 5a1.86 1.86 0 0 1-1.11.31A1.42 1.42 0 0 1 5 15.25Z"></path>
        `;
      } else {
        $('.custom_banner_slider').slick('slickPlay');
        svg.innerHTML = `
          <g class="control-icon-pause">
            <rect width="4.5" height="14" x="3.75" y="3" rx="1.5"></rect>
            <rect width="4.5" height="14" x="11.75" y="3" rx="1.5"></rect>
          </g>
        `;
      }
      isPlaying = !isPlaying;
    });
});




  document.addEventListener("DOMContentLoaded", function () {
    const stickyContainer = document.querySelector('.product____sticky');
    const textClass = `sample_kit_main`;
    // const sourceElement = document.querySelector(`.${textClass}`);
    const sampleKitMain = document.querySelector('.sample_kit_main');
    const price = document.querySelector('.sample_kit_price');
    const varId = price?.getAttribute('varId');
    const elementsToWatch = [
      document.querySelector('.stay___sticky')
    ];
    // stickyContainer.innerHTML = sourceElement.innerHTML;
    stickyContainer.innerHTML = `<div class="simple_sample" onclick="upsellAdd(${varId},1)"><div class="head">Add Sample Kit to Cart</div><div class="head_price_bls"></div></div>`;
    const visibilityMap = new Map(elementsToWatch.map(el => [el, true]));
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        visibilityMap.set(entry.target, entry.isIntersecting);
        let ssdd = document.querySelector('.head_price_bls');
        ssdd.innerHTML = price.innerHTML;
        const anyOutOfView = [...visibilityMap.values()].includes(false);
        stickyContainer.style.display = anyOutOfView ? 'block' : 'none';
      });
    }, {
      root: null,
      threshold: 0
    });
    elementsToWatch.forEach(el => observer.observe(el));
  });

// WISHLIST
var unfilledButton = document.querySelector(".my-icon-unfilled");
if (unfilledButton.parentNode) {
  unfilledButton.parentNode.removeChild(unfilledButton);
}
elem.insertAdjacentElement('afterbegin', filledIconElement);
  
